var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(
				_vm.$route.path.indexOf('login') === -1 &&
				_vm.$route.path.indexOf('sigin') === -1 &&
				_vm.$route.path.indexOf('userInfs') === -1
			)?_c('header-top'):_vm._e(),_c('keep-alive',{attrs:{"include":"indexPage"}},[_c('router-view')],1),_c('audio',{ref:"errorAudio",staticClass:"voice-dom",attrs:{"src":_vm.errorVoice,"controlslist":"nodownload","controls":"controls"}}),_c('audio',{ref:"properAudio",staticClass:"voice-dom",attrs:{"src":_vm.properVoice,"controlslist":"nodownload","controls":"controls"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }